import { render } from "./WantToRegister.vue?vue&type=template&id=0b08d3df"
import script from "./WantToRegister.vue?vue&type=script&lang=js"
export * from "./WantToRegister.vue?vue&type=script&lang=js"

import "./WantToRegister.vue?vue&type=style&index=0&id=0b08d3df&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__